import { render, staticRenderFns } from "./surface_app.vue?vue&type=template&id=45eb68f0&scoped=true&"
import script from "./surface_app.vue?vue&type=script&lang=ts&"
export * from "./surface_app.vue?vue&type=script&lang=ts&"
import style0 from "./surface_app.vue?vue&type=style&index=0&id=45eb68f0&prod&lang=scss&"
import style1 from "./surface_app.vue?vue&type=style&index=1&id=45eb68f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb68f0",
  null
  
)

export default component.exports